/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Shot_TimingInputs */



/**
* | output |
* | --- |
* | "Shot Timing" |
*
* @param {Ccsl_Export_Header_Shot_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_shot_timing = /** @type {((inputs?: Ccsl_Export_Header_Shot_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Shot_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timing du plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schuss-Timing")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempismo di tiro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время выполнения удара")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización del disparo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拍摄时机")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットタイミング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट टाइमिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronização do disparo")
	return /** @type {LocalizedString} */ ("Shot Timing")
});